import CopyCode from 'app/common/components/copy-code';
import EntitlementsWrapper from 'app/common/components/entitlements-wrapper';
import type { UsefulSnippitsProps } from './useful-snippits-hook.js';

export const UsefulSnippits = (props: UsefulSnippitsProps) => {
  const { projectId, apiEndpoint, mcpEndpoint, cdnEndpoint, onCopy } = props;

  return (
    <div className="p-4">
      <h3 className="font-semibold text-gray-900 mb-4">Useful Snippets</h3>
      <div className="space-y-4">
        <div data-testid="project-id__container">
          <div className="text-sm font-medium text-gray-700 mb-1 block">Project ID</div>
          <CopyCode code={projectId} onCopy={onCopy} />
        </div>
        <div data-testid="api-endpoint__container">
          <div className="text-sm font-medium text-gray-700 mb-1 block">API Endpoint</div>
          <CopyCode code={apiEndpoint} onCopy={onCopy} />
        </div>
        <div data-testid="mcp-endpoint__container">
          <div className="text-sm font-medium text-gray-700 mb-1 block">MCP Endpoint</div>
          <CopyCode code={mcpEndpoint} onCopy={onCopy} />
        </div>
        <EntitlementsWrapper entitlement="apiCdn">
          <div data-testid="cdn-endpoint__container">
            <div className="text-sm font-medium text-gray-700 mb-1 block">CDN Endpoint</div>
            <CopyCode code={cdnEndpoint} onCopy={onCopy} />
          </div>
        </EntitlementsWrapper>
      </div>
    </div>
  );
};
